const LOGO_URL = "/kaffa-logo.png";

export const KaffaLogo = ({ className = "", small = false, hideText = false }) => (
  <div className={`flex items-center gap-2 sm:gap-3 ${className}`}>
    <div className={`relative ${small ? "h-7 w-7 sm:h-8 sm:w-8" : "h-8 w-8 sm:h-10 sm:w-10"} shrink-0`}>
      <img
        src={LOGO_URL}
        alt="Kaffa Exchange"
        className="h-full w-full object-contain"
        loading="eager"
      />
    </div>
    {!hideText && (
      <div className="flex flex-col leading-none">
        <span className={`font-display font-black tracking-tight ${small ? "text-sm sm:text-base" : "text-base sm:text-xl"} text-foreground`}>
          KAFFA
        </span>
        <span className="font-mono-data text-[9px] sm:text-[0.6rem] uppercase tracking-[0.2em] sm:tracking-[0.25em] text-muted-foreground">
          Exchange
        </span>
      </div>
    )}
  </div>
);

export const KaffaMark = ({ className = "" }) => (
  <img src={LOGO_URL} alt="Kaffa" className={className} loading="eager" />
);

export const KAFFA_LOGO_URL = LOGO_URL;
